import { jsx as _jsx } from "react/jsx-runtime";
import { HtmlRenderer } from 'components/htmlRenderer';
import { ShadowDom } from 'components/shadowDom';
import emailRendererShadowDomStylesheet from './assets/styles/emailRendererShadowDom.scss?source';
import emailReplyQuoteStylesheet from './assets/styles/emailReplyQuote.scss?source';
import { replaceReplyQuote } from './utils/replaceReplyQuote';
/**
 * Renders html text as email by finding quotes and moving them into a
 * collapsible quote section.
 */
export const EmailRenderer = ({ html }) => {
    return (_jsx(ShadowDom, Object.assign({ stylesheets: [
            emailRendererShadowDomStylesheet,
            emailReplyQuoteStylesheet,
        ] }, { children: _jsx(HtmlRenderer, { html: html, sanitizationProfileType: "email", replace: replaceReplyQuote }) })));
};
